module.exports = __webpack_public_path__ + "img/3.5a3fb5fb.png";